
export const getLanguage = state => state.language.language;
export const getDirection = state => state.language.direction;



// WEBPACK FOOTER //
// ./src/store/language/selectors.js